const ColorDiscover = () => (
<svg
   width="42.203682mm"
   height="26.987mm"
   viewBox="0 0 42.203682 26.986999"
   version="1.1"
   xmlns="http://www.w3.org/2000/svg">
  <defs
     id="defs1">
    <linearGradient
       id="linear-gradient"
       x1="124.02"
       y1="-17.84"
       x2="35.490002"
       y2="123.84"
       gradientTransform="matrix(0.26458333,0,0,-0.26458333,0.01942728,27.541667)"
       gradientUnits="userSpaceOnUse">
      <stop
         offset="0"
         stopColor="#f4a01e"
         id="stop1" />
      <stop
         offset="0.13"
         stopColor="#f39b1f"
         id="stop2" />
      <stop
         offset="0.25"
         stopColor="#f29220"
         id="stop3" />
      <stop
         offset="0.33"
         stopColor="#ee8422"
         id="stop4" />
      <stop
         offset="0.39"
         stopColor="#ed7c23"
         id="stop5" />
      <stop
         offset="0.49"
         stopColor="#ec7323"
         id="stop6" />
      <stop
         offset="0.6"
         stopColor="#ec6e26"
         id="stop7" />
      <stop
         offset="0.78"
         stopColor="#ec6c29"
         id="stop8" />
    </linearGradient>
    <linearGradient
       id="linear-gradient-2"
       x1="84.989998"
       y1="43.470001"
       x2="72.830002"
       y2="62.919998"
       gradientTransform="matrix(0.26458333,0,0,-0.26458333,0.01942728,27.541667)"
       gradientUnits="userSpaceOnUse">
      <stop
         offset="0"
         stopColor="#f4a01e"
         id="stop9" />
      <stop
         offset="0.19"
         stopColor="#f39b1f"
         id="stop10" />
      <stop
         offset="0.37"
         stopColor="#f29220"
         id="stop11" />
      <stop
         offset="0.5"
         stopColor="#ee8422"
         id="stop12" />
      <stop
         offset="0.6"
         stopColor="#ec7a23"
         id="stop13" />
      <stop
         offset="0.76"
         stopColor="#eb7224"
         id="stop14" />
      <stop
         offset="1"
         stopColor="#eb6f24"
         id="stop15" />
    </linearGradient>
    <linearGradient
       id="linear-gradient-3"
       x1="84.989998"
       y1="43.470001"
       x2="72.830002"
       y2="62.919998"
       gradientTransform="matrix(0.26458333,0,0,-0.26458333,0.01942728,27.541667)"
       gradientUnits="userSpaceOnUse">
      <stop
         offset="0"
         stopColor="#f3951f"
         stopOpacity="0"
         id="stop16" />
      <stop
         offset="0.2"
         stopColor="#f47b20"
         stopOpacity="0.24"
         id="stop17" />
      <stop
         offset="0.49"
         stopColor="#f15c22"
         stopOpacity="0.56"
         id="stop18" />
      <stop
         offset="0.73"
         stopColor="#ef4623"
         stopOpacity="0.8"
         id="stop19" />
      <stop
         offset="0.91"
         stopColor="#ef3c23"
         stopOpacity="0.94"
         id="stop20" />
      <stop
         offset="1"
         stopColor="#ef3824"
         id="stop21" />
    </linearGradient>
    <clipPath
       id="clip-path">
      <path
         className="cls-1"
         d="M 67.44,50.81 A 11.47,11.47 0 1 0 78.91,39.34 11.47,11.47 0 0 0 67.44,50.81 v 0"
         id="path21" />
    </clipPath>
    <radialGradient
       id="radial-gradient"
       cx="80.529999"
       cy="50.540001"
       r="15.04"
       gradientTransform="matrix(1,0,0,-1,0,104)"
       gradientUnits="userSpaceOnUse">
      <stop
         offset="0"
         stopColor="#f3951f"
         stopOpacity="0"
         id="stop22" />
      <stop
         offset="0.48"
         stopColor="#e98c24"
         stopOpacity="0.05"
         id="stop23" />
      <stop
         offset="0.7"
         stopColor="#c47329"
         stopOpacity="0.23"
         id="stop24" />
      <stop
         offset="0.86"
         stopColor="#87471f"
         stopOpacity="0.54"
         id="stop25" />
      <stop
         offset="0.99"
         stopColor="#2e110f"
         stopOpacity="0.97"
         id="stop26" />
      <stop
         offset="1"
         stopColor="#290f0f"
         id="stop27" />
    </radialGradient>
  </defs>
  <g
     id="layer1"
     transform="translate(-0.01942728,-0.02499774)">
    <path
       className="cls-8"
       d="M 0.48244828,1.4140577 V 25.623437 a 0.92604165,0.92604165 0 0 0 0.92604092,0.92604 H 27.11276 a 13.033375,13.033375 0 0 0 13.03337,-13.03073 v 0 A 13.030729,13.030729 0 0 0 27.11276,0.48801774 H 1.4084892 A 0.92604165,0.92604165 0 0 0 0.48244828,1.4140577 Z"
       id="path33"
       fill="#ffffff"
       strokeWidth="0.264583" />
    <path
       className="cls-9"
       d="M 40.83141,0.02499774 H 1.4084892 A 1.3890625,1.3890625 0 0 0 0.01942728,1.4140577 v 0 24.2093793 a 1.3890625,1.3890625 0 0 0 1.38906192,1.38906 H 40.83141 a 1.3917083,1.3917083 0 0 0 1.3917,-1.38906 v 0 V 1.4140577 A 1.3917083,1.3917083 0 0 0 40.83141,0.02499774 Z M 40.14613,13.518747 A 13.033375,13.033375 0 0 1 27.11276,26.546827 H 1.4084892 a 0.92604165,0.92604165 0 0 1 -0.92604092,-0.92604 v 0 V 1.4140577 A 0.92604165,0.92604165 0 0 1 1.4084892,0.48801774 H 27.11276 A 13.030729,13.030729 0 0 1 40.14613,13.518747 Z"
       id="path34"
       fill="url(#linear-gradient)"
       strokeWidth="0.264583" />
    <path
       className="cls-10"
       d="m 3.6336352,10.608327 h -1.640416 v 5.73088 h 1.632479 a 3.0030208,3.0030208 0 0 0 2.045229,-0.66146 2.8839583,2.8839583 0 0 0 1.039812,-2.19869 c 0,-1.69333 -1.264708,-2.87073 -3.077104,-2.87073 m 1.307042,4.30477 c -0.351896,0.3175 -0.809625,0.45773 -1.529292,0.45773 h -0.301625 v -3.79148 h 0.301625 c 0.719667,0 1.158875,0.12965 1.529292,0.46302 a 1.920875,1.920875 0 0 1 0.616479,1.42611 1.9579166,1.9579166 0 0 1 -0.616479,1.44462"
       id="path35"
       fill="#010101"
       strokeWidth="0.264583" />
    <rect
       className="cls-10"
       x="7.2240319"
       y="10.608327"
       width="1.1165416"
       height="5.730875"
       id="rect35"
       fill="#010101"
       strokeWidth="0.264583" />
    <path
       className="cls-10"
       d="m 11.073719,12.807017 c -0.669396,-0.24871 -0.867834,-0.4101 -0.867834,-0.71967 0,-0.36248 0.351896,-0.635 0.833438,-0.635 a 1.1482917,1.1482917 0 0 1 0.902229,0.46302 l 0.584729,-0.76464 a 2.5056041,2.5056041 0 0 0 -1.685396,-0.63765 c -1.0133543,0 -1.7859368,0.70644 -1.7859368,1.64307 0,0.79375 0.359833,1.19327 1.4102288,1.57162 a 4.4979166,4.4979166 0 0 1 0.772583,0.32015 0.68791666,0.68791666 0 0 1 0.336021,0.59266 0.81756249,0.81756249 0 0 1 -0.8255,0.80963 h -0.04498 a 1.3229166,1.3229166 0 0 1 -1.2197288,-0.76465 l -0.719667,0.69586 a 2.2277916,2.2277916 0 0 0 1.9817288,1.09008 c 1.161521,0 1.976438,-0.77258 1.976438,-1.88119 0,-0.91016 -0.375709,-1.32291 -1.648354,-1.78858"
       id="path36"
       fill="#010101"
       strokeWidth="0.264583" />
    <path
       className="cls-10"
       d="m 13.076614,13.479057 a 2.9659791,2.9659791 0 0 0 2.942167,2.98979 h 0.08202 a 3.0982708,3.0982708 0 0 0 1.399649,-0.33337 v -1.32292 a 1.7753541,1.7753541 0 0 1 -1.34144,0.63236 1.87325,1.87325 0 0 1 -1.926168,-1.81505 c 0,-0.0529 0,-0.10847 0,-0.16139 a 1.905,1.905 0 0 1 1.852084,-1.96586 h 0.03175 a 1.8679583,1.8679583 0 0 1 1.399644,0.64294 v -1.32291 a 2.8654375,2.8654375 0 0 0 -1.373186,-0.3519 3.0136041,3.0136041 0 0 0 -3.066521,2.9845 v 0.0238"
       id="path37"
       fill="#010101"
       strokeWidth="0.264583" />
    <polygon
       className="cls-10"
       points="98.37,62.22 100.64,62.22 110,40 105.42,40 99.57,54.55 93.79,40 89.18,40 "
       id="polygon37"
       fill="#010101"
       transform="matrix(0.26458333,0,0,0.26458333,0.01942728,0.02499774)" />
    <polygon
       className="cls-10"
       points="116.13,57.99 116.13,52.15 123.6,52.15 123.6,48.48 116.13,48.48 116.13,43.67 123.89,43.67 123.89,40 111.91,40 111.91,61.66 123.89,61.66 123.89,57.99 "
       id="polygon38"
       fill="#010101"
       transform="matrix(0.26458333,0,0,0.26458333,0.01942728,0.02499774)" />
    <path
       className="cls-10"
       d="m 37.22249,12.299017 c 0,-1.05833 -0.73819,-1.69069 -2.02671,-1.69069 h -1.65894 v 5.73088 h 1.11654 v -2.29129 h 0.14553 l 1.54781,2.30187 h 1.37583 l -1.80446,-2.41564 a 1.524,1.524 0 0 0 1.3044,-1.62455 m -2.24102,0.94457 h -0.32809 v -1.74361 h 0.34396 c 0.6985,0 1.07421,0.29104 1.07421,0.84931 0,0.55828 -0.37571,0.8943 -1.09008,0.8943"
       id="path38"
       fill="#010101"
       strokeWidth="0.264583" />
    <path
       className="cls-10"
       d="m 38.11943,10.909957 c 0,-0.10054 -0.0688,-0.15611 -0.19315,-0.15611 h -0.1614 v 0.50536 h 0.12171 v -0.19579 l 0.14023,0.19579 h 0.14817 l -0.16669,-0.20902 a 0.14022916,0.14022916 0 0 0 0.11113,-0.14023 m -0.21167,0.0688 h -0.0212 v -0.13229 h 0.0212 c 0.0609,0 0.09,0.0212 0.09,0.0635 0,0.0423 -0.0317,0.0688 -0.09,0.0688"
       id="path39"
       fill="#010101"
       strokeWidth="0.264583" />
    <path
       className="cls-10"
       d="m 37.94745,10.563347 a 0.44185416,0.44185416 0 0 0 -0.44715,0.43657 0.44185416,0.44185416 0 0 0 0.88106,0 v 0 a 0.43920833,0.43920833 0 0 0 -0.43391,-0.44186 m 0,0.79375 a 0.36247916,0.36247916 0 1 1 0.34925,-0.37571 v 0 a 0.35983333,0.35983333 0 0 1 -0.34925,0.36248"
       id="path40"
       fill="#010101"
       strokeWidth="0.264583" />
    <path
       className="cls-11"
       d="m 17.86293,13.468477 a 3.0347708,3.0347708 0 1 0 3.03477,-3.03477 3.0347708,3.0347708 0 0 0 -3.03477,3.03477 v 0"
       id="path41"
       fill="url(#linear-gradient-2)"
       strokeWidth="0.264583" />
    <path
       className="cls-12"
       d="m 17.86293,13.468477 a 3.0347708,3.0347708 0 1 0 3.03477,-3.03477 3.0347708,3.0347708 0 0 0 -3.03477,3.03477 v 0"
       id="path42"
       fill="url(#linear-gradient-3)"
       strokeWidth="0.264583" />
    <g
       className="cls-13"
       clipPath="url(#clip-path)"
       id="g43"
       transform="matrix(0.26458333,0,0,0.26458333,0.01942728,0.02499774)">
      <path
         className="cls-14"
         d="m 65.49,53.46 a 15,15 0 1 0 15,-15 15,15 0 0 0 -15,15 v 0"
         id="path43"
         fill="url(#radial-gradient)" />
    </g>
  </g>
</svg>

)
export default ColorDiscover
